import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, change } from 'redux-form';
import { Button } from 'semantic-ui-react';
import { InputField, CheckboxField } from 'Common/SemanticWrapper';
import _ from 'lodash';

import {
  RecipeVerified as Verified,
  AttributeFieldEnum as AttributeFields,
} from 'Common/FieldEnum';
import { NOTIFICATION_DIALOG_MESSAGES } from 'Common/Constants';
import { setNotificationDialog } from 'Components/dialogs/state/actions';

export default class Attributes extends Component {
  static propTypes = {
    formName: PropTypes.string.isRequired,
    isReadOnly: PropTypes.bool,
  };

  static defaultProps = {
    isReadOnly: false,
  };

  unverified = (key) => {
    const { dispatch, formName } = this.props;
    dispatch(change(formName, `${AttributeFields.Verified}.${key}`, false));
  };

  verified = (key) => {
    const { dispatch, formName } = this.props;
    dispatch(change(formName, `${AttributeFields.Verified}.${key}`, true));
  };

  handleAttributeRowClick = (attribute, recipeAttributes) => {
    const { dispatch, formValues, formName } = this.props;
    const foundRecipeattribute = recipeAttributes.find(
      (recipeAttribute) => recipeAttribute.Id === attribute.Id
    );

    if (foundRecipeattribute && foundRecipeattribute.FromIngredient) {
      dispatch(
        setNotificationDialog(
          NOTIFICATION_DIALOG_MESSAGES.ATTRIBUTE_FROM_INGREDIENT
        )
      );
      return;
    }

    let attributes = [];
    if (formValues[AttributeFields.Attributes]) {
      attributes = formValues[AttributeFields.Attributes];
    }

    const attributeIds = attributes.map((a) => a.Id);
    if (!attributeIds.includes(attribute.Id)) {
      attributes.push({
        Id: attribute.Id,
        Description: attribute.Description,
        FromIngredient: false,
      });
    } else {
      attributes = attributes.filter((a) => a.Id !== attribute.Id);
    }

    dispatch(change(formName, AttributeFields.Attributes, attributes));
    this.unverified(Verified.Attributes);
  };

  handleAddAttributeClick = (e) => {
    const { dispatch, formValues, formName } = this.props;

    const formAttributes = formValues[AttributeFields.AllAttributes]
      ? formValues[AttributeFields.AllAttributes]
      : [];
    const allAttributes = [...formAttributes];
    if (
      _.find(allAttributes, (attribute) => attribute.Description.trim() === '')
    ) {
      return;
    }

    allAttributes.push({
      Id: parseInt(_.uniqueId('100000'), 10),
      Description: '',
      FromIngredient: false,
      IsNew: true,
    });
    dispatch(change(formName, AttributeFields.AllAttributes, allAttributes));
  };

  render() {
    const { formValues, isReadOnly } = this.props;
    const { handleAttributeRowClick, handleAddAttributeClick } = this;

    let allAttributes = [];
    let attributes = [];

    if (formValues[AttributeFields.AllAttributes]) {
      allAttributes = formValues[AttributeFields.AllAttributes];
    }

    if (formValues[AttributeFields.Attributes]) {
      attributes = formValues[AttributeFields.Attributes];
    }

    const attributeIds = attributes.map((a) => a.Id);
    const attributeList = allAttributes.map((attribute, i) => {
      return (
        <div className="row input" key={attribute.Id}>
          <Field
            component={CheckboxField}
            label={false}
            onChange={() => handleAttributeRowClick(attribute, attributes)}
            checked={attributeIds.includes(attribute.Id)}
            name={`attribute-${i}`}
            disabled={isReadOnly}
          />
          {attribute.IsNew && (
            <Field
              component={InputField}
              label={false}
              hideEmptyError={true}
              name={`${AttributeFields.AllAttributes}[${i}].Description`}
              maxLength="60"
              disabled={isReadOnly}
            />
          )}
          {!attribute.IsNew && (
            <div>
              {formValues[AttributeFields.AllAttributes][i].Description}
            </div>
          )}
        </div>
      );
    });

    const isVerified = _.get(
      formValues,
      [AttributeFields.Verified, Verified.Attributes],
      false
    );

    return (
      <div className="attributes-container">
        <div className="button-container">
          <Button
            onClick={() => this.verified(Verified.Attributes)}
            fluid
            color={isVerified ? 'green' : 'orange'}
            disabled={isReadOnly}
          >
            {isVerified ? 'Verified' : 'Click to Verify'}
          </Button>
        </div>
        <span className="break" />
        {attributeList}
        <div className="button-container">
          <Button
            onClick={handleAddAttributeClick}
            fluid
            color="green"
            disabled={isReadOnly}
          >
            Add Custom Attribute
          </Button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/Components/Attributes/Attributes.js